import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Enquiry } from 'src/app/models/enquiry.model';
import { environment } from 'src/environments/environment';
import { Title, Meta } from '@angular/platform-browser';
import { ModalService } from 'src/app/services/modal.service';
@Component({
  selector: 'app-database-mastery',
  templateUrl: './database-mastery.component.html',
  styleUrls: ['./database-mastery.component.scss']
})
export class DatabaseMasteryComponent implements OnInit {
  course_details = environment.course_date_advanced_data_science_and_AI;
  certificateImage = 'assets/img/live-courses/certificate/Database-Mastery.png';
  course_date_month = environment.course_date_month;
  enquiry: Enquiry = new Enquiry();
  moduleQuestion: any[] = [];
  filteredDataFromModule: { Id: number; actve: boolean }[];
  contactForm: FormGroup;
  course_class_mode_text = [
    '🔴 Live Interactive Sessions',
    '🎥 Access to Class Recordings',
    '❓Dedicated Doubt Support',
    '🏆 Course Certification',
    '🛠 Hands-on Project Work',
    '🎁 Final Assessment with Exciting Goodies'
  ]
  currentTextIndex: number = 0;
  classFeature: string = this.course_class_mode_text[this.currentTextIndex];
  feedbackSlides: OwlOptions = {
    loop: true,
    nav: true,
    dots: false,
    animateOut: false,
    autoplayHoverPause: false,
    autoplay: false,
    mouseDrag: false,
    items: 2,
    margin: 10,
    navText: [
      "<i class='bx bx-left-arrow-alt'></i>",
      "<i class='bx bx-right-arrow-alt'></i>"
    ],
    responsive: {
      0: {
        items: 1
      },
      576: {
        items: 1
      },
      768: {
        items: 2
      },
      1200: {
        items: 2
      }
    }
  }
  courseCASEstudyHLD = [
    {
      title: 'Design URL Shortener Service',
      text: `“A URL shortener service creates a short url against a long url. Moreover, when we click on the short/tiny url, it get redirected to the actual url”`,
      Img: '/assets/img/courses/courses_custom/short-url.jpg',
    },
    {
      title: 'Design OTT Platform Like Netflix',
      text: `"Here we will learn the architecture of video streaming platform and how to create an on-demand video streaming app like Netflix”`,
      Img: '/assets/img/courses/courses_custom/netflix.jpg',
    },
    {
      title: 'Design Social Media News Feed',
      text: `"Here we will learn how to design Facebook/Insta’s news feed kind of service, which notify updates from all the users”`,
      Img: '/assets/img/courses/courses_custom/facebook-insta-news-feed.jpg',
    },
    {
      title: 'Design Cab Booking System Like UBER',
      text: `“Here we will learn the architecture of cab booking system and how to design a system like UBER ”`,
      Img: '/assets/img/courses/courses_custom/car-booking.jpg',
    },
    {
      title: 'Design Messaging System Like Whatsapp',
      text: `"Here we will learn the architecture of real time messaging/chat system like Whatsapp”`,
      Img: '/assets/img/courses/courses_custom/whatsapp.jpg',
    }
  ];
  courseCASEstudyLLD = [
    {
      title: 'Design Parking Lot',
      text: `“Here we will learn how to gather requirement for a parking lot kind of system and also complete design of low level code”`,
      Img: '/assets/img/courses/courses_custom/parking-lot.jpg',
    },
    {
      title: 'Design Movie Ticket Booking App',
      text: `"Here we will learn how to design the architecture of a movie booking kind of system and its low level code using OOD principle”`,
      Img: '/assets/img/courses/courses_custom/Moview Ticket-Booking-System.jpg',
    },
    {
      title: 'Design Tic-Tac-Toe Game',
      text: `Here we will deep dive into low level design of a gaming app like Tic-tac-toe with complete class design with implementation”`,
      Img: '/assets/img/courses/courses_custom/tic-tac-toe.jpg',
    },
    {
      title: 'Design a Logging Service',
      text: `"Logging is essential in understanding the event flow in a distributed system. Here we will learn about distributed logging with implementation.”`,
      Img: '/assets/img/courses/courses_custom/logging-service.jpg',
    },
    {
      title: 'Design a Caching Service',
      text: `"Here we will learn about importance/need of cache in a system and different caching techniques with implementation.”`,
      Img: '/assets/img/courses/courses_custom/caching-service.jpg',
    },
    {
      title: 'Design Expense Sharing app like Splitwise',
      text: `"Here we will learn the architecture of splitwise and its low level design with implementation.”`,
      Img: '/assets/img/courses/courses_custom/splitwise-app.jpg',
    }
  ];
  utmSource: string;
  timer: number = 0;
  isButtonDisable: boolean = false;

  mentor = {
    name: 'Sayan Naskar',
    title2: '',
    title: 'Software Engineer at Microsoft',
    image: 'assets/img/live-courses/sayan.jpg', // Update with actual image path
    linkedinUrl: 'https://www.linkedin.com/in/nascarsayan/'
  };

  stats = [
    { value: '2000+', label: 'Students Mentored' },
    { value: 'Software Engineer at Microsoft', label: 'Dual Degree,  IIT KGP' },

  ];
  constructor(private route: ActivatedRoute,
    private modalService: ModalService,
    private metaService: Meta, private titleService: Title) { }

  ngOnInit(): void {
    this.updateMetaTags('Mastering Advance Data Science & Generative AI', 'Discover the world of Data Science and Generative AI in this transformative course. Develop crucial skills for data-driven decision-making and delve into the dynamic world of Generative Artificial Intelligence.');
    // Accessing route parameters
    this.route.queryParams.subscribe(params => {
      this.utmSource = params['utmsource'];
    });
    setInterval(() => {
      this.currentTextIndex = (this.currentTextIndex + 1) % this.course_class_mode_text.length;
      this.classFeature = this.course_class_mode_text[this.currentTextIndex];
    }, 3000);
  }

  updateMetaTags(title: string, description: string) {
    this.titleService.setTitle(title);
    this.metaService.updateTag({ name: 'description', content: description });
  }

  moduleArray = [
    {
      id: 1,
      active: false,
      courseTopic: 'Introduction to DBMS & SQL Fundamentals',
      timeTaking: '1st week',
      isProjectInclude: false,
      childProperties: [
        {
          id: 1,
          module_description: 'Establish a robust data-driven groundwork with the first module, Foundations of Data Science.',
          moduleContant: [
            {
              topicName: 'Topics Covered',
              subTopics: [
                {
                  subTopicTitle: '',
                  subTopicTitleContent: [
                    'Overview of database systems and their evolution.',
                    'Relational model fundamentals: tables, keys, and integrity constraints.',
                    'Introduction to SQL: creating databases, defining schemas, and basic DML (SELECT, INSERT, UPDATE, DELETE).'
                  ]
                }

              ]
            },
            {
              topicName: 'Combined Theory/Practice:',
              subTopics: [
                {
                  subTopicTitle: 'Session Activity',
                  subTopicTitleContent: [
                    'Set up a SQLite database',
                    'Use DataGrip to connect to SQLite and practice writing basic SQL queries.',
                    'Explore how schema definitions enforce data integrity.'
                  ]
                },
                {
                  subTopicTitle: 'Discussion & Exercise',
                  subTopicTitleContent: [
                    'Analyze real-world scenarios and decide on the proper schema design for a simple application.',
                  ]
                },
              ]
            },
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                ''
              ]
            }
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 2,
      active: false,
      courseTopic: ' Data Modeling, Normalization & Schema Design',
      timeTaking: '2nd week',
      isProjectInclude: false,
      childProperties: [
        {
          id: 1,
          module_description: 'Establish a robust data-driven groundwork with the first module, Foundations of Data Science.',
          moduleContant: [
            {
              topicName: 'Topics Covered',
              subTopics: [
                {
                  subTopicTitle: '',
                  subTopicTitleContent: [
                    'Entity‑Relationship (ER) modeling and conversion to relational schemas.',
                    'Normalization techniques (1NF, 2NF, 3NF, BCNF) and identifying anomalies.',
                    'Practical schema design and refinement.'
                  ]
                }

              ]
            },

            {
              topicName: 'Combined Theory/Practice:',
              subTopics: [
                {
                  subTopicTitle: 'Session Activity',
                  subTopicTitleContent: [
                    'Design an ER diagram for a sample business scenario (e.g., a small e‑commerce system) and convert it into a relational schema.',
                    'Implement the schema in SQLite using DataGrip.',
                  ]
                },
                {
                  subTopicTitle: 'Exercise',
                  subTopicTitleContent: [
                    'Write integrated queries to test data integrity and normalization; discuss trade‑offs and possible denormalization scenarios.',
                  ]
                },
              ]
            },
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                ''
              ]
            }
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 3,
      active: false,
      courseTopic: 'Concurrency & Synchronization',
      timeTaking: '3rd week',
      isProjectInclude: false,
      childProperties: [
        {
          id: 1,
          module_description: 'Establish a robust data-driven groundwork with the first module, Foundations of Data Science.',
          moduleContant: [
            {
              topicName: 'Topics Covered',
              subTopics: [
                {
                  subTopicTitle: '',
                  subTopicTitleContent: [
                    'How SQL queries are processed: parsing, optimization, and execution.',
                    'Relational algebra concepts and their relationship with SQL.',
                    'Index structures (B‑trees, hash indexes) and their impact on performance.',
                    'Query plan analysis and optimization techniques.'
                  ]
                }

              ]
            },

            {
              topicName: 'Combined Theory/Practice:',
              subTopics: [
                {
                  subTopicTitle: 'Session Activity',
                  subTopicTitleContent: [
                    'Write a series of SQL queries with varying complexity.',
                    'Use DataGrip’s explain plan or similar tool to examine query execution.',
                    'Experiment with creating and dropping indexes in SQLite to observe performance differences.'
                  ]
                },
                {
                  subTopicTitle: 'Discussion & Exercise',
                  subTopicTitleContent: [
                    'Modify queries and indexes to optimize performance on sample datasets, documenting observations.',
                  ]
                },
              ]
            },
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                ''
              ]
            }
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 4,
      active: false,
      courseTopic: 'Transaction Management, Concurrency Control & WAL',
      timeTaking: '4th week',
      isProjectInclude: false,
      childProperties: [
        {
          id: 1,
          module_description: 'Establish a robust data-driven groundwork with the first module, Foundations of Data Science.',
          moduleContant: [
            {
              topicName: 'Topics Covered',
              subTopics: [
                {
                  subTopicTitle: '',
                  subTopicTitleContent: [
                    'Transaction properties and the importance of ACID (Atomicity, Consistency, Isolation, Durability).',
                    'Concurrency control mechanisms: locking, multiversion concurrency control (MVCC), and isolation levels.',
                    'Write-Ahead Logging (WAL): its role in ensuring durability and enabling crash recovery.',
                    'Recovery techniques: checkpoints and log-based recovery.'
                  ]
                }

              ]
            },


            {
              topicName: 'Combined Theory/Practice:',
              subTopics: [
                {
                  subTopicTitle: 'Session Activity',
                  subTopicTitleContent: [
                    'Develop a small application (or script) to simulate concurrent transactions on a SQLite database.',
                    'Observe SQLite’s WAL mode in action (enable WAL mode, perform transactions, and simulate recovery).',
                    'Compare transaction behavior in SQLite versus PostgreSQL (for sessions dedicated to advanced topics).'
                  ]
                },
                {
                  subTopicTitle: 'Discussion & Exercise',
                  subTopicTitleContent: [
                    'Analyze different concurrency control scenarios and propose improvements to transaction throughput and recovery mechanisms.',
                  ]
                },
              ]
            },
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                ''
              ]
            }
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 5,
      active: false,
      courseTopic: 'Storage, Advanced Indexing & Recovery Mechanisms',
      timeTaking: '5th week',
      isProjectInclude: false,
      childProperties: [
        {
          id: 1,
          module_description: 'Establish a robust data-driven groundwork with the first module, Foundations of Data Science.',
          moduleContant: [
            {
              topicName: 'Topics Covered',
              subTopics: [
                {
                  subTopicTitle: '',
                  subTopicTitleContent: [
                    'File storage architectures: heap files, sorted files, and indexing structures.',
                    'In‑depth exploration of index types and their implementation details.',
                    'Recovery strategies in depth: detailed look at write‑ahead logging and checkpointing.',
                    'Introduction to advanced storage techniques in PostgreSQL.'
                  ]
                }
              ]
            },

            {
              topicName: 'Combined Theory/Practice:',
              subTopics: [
                {
                  subTopicTitle: 'Session Activity',
                  subTopicTitleContent: [
                    'Implement a basic simulation of an index (e.g., a B‑tree) in a programming language.',
                    'Explore DataGrip’s features to monitor index performance and recovery logs.',
                    'Perform exercises on recovery by simulating failures and analyzing log files in SQLite and PostgreSQL.'
                  ]
                },
                {
                  subTopicTitle: 'Discussion & Exercise',
                  subTopicTitleContent: [
                    'Document the behavior of WAL and checkpoint processes and compare the two DB engines.',
                  ]
                },
              ]
            },
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                ''
              ]
            }
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 6,
      active: false,
      courseTopic: 'Advanced Topics & Capstone Integration',
      timeTaking: '6th week',
      isProjectInclude: true,
      childProperties: [
        {
          id: 1,
          module_description: 'Establish a robust data-driven groundwork with the first module, Foundations of Data Science.',
          moduleContant: [
            {
              topicName: 'Topics Covered',
              subTopics: [
                {
                  subTopicTitle: '',
                  subTopicTitleContent: [
                    'Exploring emerging trends: NoSQL, NewSQL, and distributed databases.',
                    'Detailed comparisons between SQLite and PostgreSQL in terms of features and performance.',
                    'Integrating various DBMS components for robust, high-availability systems.',
                    'Final capstone project: a comprehensive application that integrates advanced query optimization, transaction management, and recovery.'
                  ]
                }
              ]
            },

            {
              topicName: 'Combined Theory/Practice:',
              subTopics: [
                {
                  subTopicTitle: 'Session Activity',
                  subTopicTitleContent: [
                    'Work on a capstone project using DataGrip to design and manage a database that meets a complex set of requirements (e.g., a multi‑user inventory system).',
                    'Implement advanced features such as complex join queries, stored procedures (in PostgreSQL), and custom recovery tests.',
                    'Evaluate the trade‑offs between using SQLite for lightweight applications versus PostgreSQL for advanced requirements.'
                  ]
                },
                {
                  subTopicTitle: 'Exercise',
                  subTopicTitleContent: [
                    'Prepare a project report that includes design decisions, performance evaluations, and a discussion on how the various DBMS components interoperate.',
                    'Present your capstone findings in a group discussion, highlighting insights from both practical experiments and theoretical analysis.'
                  ]
                },
              ]
            },
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                ''
              ]
            }
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
  ]
  eachModuleDataArr = [
    {
      Id: 1,
      actve: false,
    },
    {
      Id: 2,
      actve: false,
    },
    {
      Id: 3,
      actve: false,
    },
    {
      Id: 4,
      actve: false,
    },

    {
      Id: 5,
      actve: false,
    },
  ]
  getModuleQuestion(selectedData: any) {
    this.filteredDataFromModule = this.eachModuleDataArr.filter(qId => qId.Id == selectedData.id);
    console.log(this.filteredDataFromModule)
    for (let i = 0; i < this.moduleArray.length; i++) {
      if (this.moduleArray[i].id == selectedData.id) {
        this.moduleArray[i].active = !this.moduleArray[i].active;
      } else {
        this.moduleArray[i].active = false;
      }
    }
    this.moduleQuestion.push(this.eachModuleDataArr);
  }

  toggleAccordian(event, selectedData) {
    const element = event.target;
    element.classList.toggle("active");
    for (let i = 0; i < this.moduleArray.length; i++) {
      if (this.moduleArray[i].id == selectedData.id) {
        this.moduleArray[i].active = !this.moduleArray[i].active;
      } else {
        this.moduleArray[i].active = false;
      }
    }

    const panel = element.nextElementSibling;
    if (panel != null) {
      if (panel?.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    }
  }
  toggleCourseTitle(selectedData, index) {
    for (let i = 0; i < this.moduleArray.length; i++) {
      if (this.moduleArray[i].id == selectedData.id) {
        this.moduleArray[i].active = !this.moduleArray[i].active;
      } else {
        this.moduleArray[i].active = false;
      }
    }
  }



  downloadBroucher() {
    this.modalService.openModal();
  }
}
